import Vuex from 'vuex'
import moment from 'moment'

export default new Vuex.Store({
    state: {
        advertiser: {},
        advertisers: [],
        advertiserBalance: null,
        campaigns: [],
        impersonatingAdvertiser: false,
        usingServiceUser: false,
        locations: [],
        loadingAdvertiser: true,
        loadingSessionAdvertiser: true,
        loadingAdvertisers: true,
        loadingCampaigns: true,
        loadingLocations: true,
        stats: {},
        chartStart: moment().subtract(7, 'days').format('MM-DD-YYYY'),
        chartEnd: moment().format('MM-DD-YYYY'),
        chartInterval: 'D'
    },
    getters: {
        advertiser(state) {
            return state.advertiser;
        },
        advertisers(state) {
            return state.advertisers;
        },
        impersonatingAdvertiser(state) {
            return state.impersonatingAdvertiser;
        },
        usingServiceUser(state) {
            return state.usingServiceUser;
        },
        locations(state) {
            return state.locations;
        },
        loadingAdvertiser(state) {
            return state.loadingAdvertiser;
        },
        loadingAdvertisers(state) {
            return state.loadingAdvertisers;
        },
        loadingLocations(state) {
            return state.loadingLocations;
        },
        loadingSessionAdvertiser(state) {
            return state.loadingSessionAdvertiser;
        },
        statsPeriodTotals(state) {
            return state.stats.periodTotals;
        },
        statsItemTotals(state) {
            const itemTotals = state.stats.itemTotals;

            return itemTotals === 'undefined' ? {} : itemTotals;
        },
        campaignIds(state) {
            if (! state.campaigns || ! state.campaigns.length) {
                return [];
            }

            return state.campaigns.map((campaign) => {
                return campaign.id;
            });
        },
        dateRange(state) {
            return {
                chartStart: state.chartStart,
                chartEnd: state.chartEnd,
                chartInterval: state.chartInterval
            };
        },
        advertiserBalance(state) {
            return state.advertiserBalance;
        },
        chartInterval(state) {
            return state.chartInterval;
        }
    },
    actions: {
        fetchAdvertiser(context, payload) {
            context.commit('isLoadingAdvertiser');
            axios.get(payload.baseUrl + '/api/admin/advertiser/'+payload.id)
            .then((response) => {
                if(response.status === 200) {
                    context.commit('assignAdvertiser', response.data.advertiser);

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                }
                context.commit('notLoadingAdvertiser');
            })
            .catch(() => {
                context.commit('notLoadingAdvertiser');

                if (typeof payload.callback === 'function') {
                    payload.callback();
                }
            });
        },
        impersonateAdvertiser(context, payload) {
            context.commit('isImpersonatingAdvertiser');

            axios.get(payload.baseUrl + '/admin/advertisers/' + payload.id)
                .then((response) => {
                    context.commit('assignAdvertiser', response.data.advertiser)
                    context.commit('notImpersonatingAdvertiser')

                    if (typeof payload.callback === 'function') {
                        payload.callback()
                    }
                })
                .catch((error) => {
                    context.commit('notImpersonatingAdvertiser');
                    alert(error.response.data.message);

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                });
        },
        fetchSessionAdvertiser(context, payload) {
            context.commit('isLoadingSessionAdvertiser');
            axios.get(payload.baseUrl + '/api/advertiser')
                .then((response) => {
                    context.commit('assignAdvertiser', response.data.advertiser);
                    context.commit('notLoadingSessionAdvertiser');

                    /*
                    @todo don't naively use the 0th product_categories entry; interrogate and select based on the vertical
                    */
                    context.commit('assignAdvertiserBalance', response.data.advertiser.product_categories[0].account_balance);
                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                })
                .catch(() => {
                    context.commit('notLoadingSessionAdvertiser');

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                });
        },
        fetchAdvertisers(context, payload) {
            context.commit('isLoadingAdvertisers');
            axios.get(payload.baseUrl + '/api/admin/advertiser/')
                .then((response) => {
                    context.commit('assignAdvertisers', response.data.advertisers);
                    context.commit('notLoadingAdvertisers');

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                })
                .catch(() => {
                    context.commit('notLoadingAdvertisers');

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                });
        },
        fetchLocations(context, payload) {
            context.commit('isLoadingLocations');
            axios.get(payload.baseUrl + '/api/locations')
                .then((response) => {
                    context.commit('assignLocations', response.data.locations);
                    context.commit('notLoadingLocations');

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                })
                .catch(() => {
                    context.commit('notLoadingLocations');

                    if (typeof payload.callback === 'function') {
                        payload.callback();
                    }
                });
        },
        patchAdvertiserProductTypes(context, payload) {
            context.commit('isLoadingAdvertiser');
            axios.patch(payload.baseUrl + '/api/admin/advertiser/' + payload.advertiser.id + '/product-types', payload.advertiser).then((response) => {
                context.commit('assignAdvertiser', response.data.advertiser);
                context.commit('notLoadingAdvertiser');
            });
        }
    },
    mutations: {
        assignAdvertiser(state, payload) {
            state.advertiser = payload;
        },
        isLoadingAdvertiser(state) {
            state.loadingAdvertiser = true;
        },
        notLoadingAdvertiser(state) {
            state.loadingAdvertiser = false;
        },
        isLoadingSessionAdvertiser(state) {
            state.loadingSessionAdvertiser = true;
        },
        notLoadingSessionAdvertiser(state) {
            state.loadingSessionAdvertiser = false;
        },
        isImpersonatingAdvertiser(state) {
            state.impersonatingAdvertiser = true;
        },
        notImpersonatingAdvertiser(state) {
            state.impersonatingAdvertiser = false;
        },
        usingServiceUser(state, payload) {
            state.usingServiceUser = payload;
        },
        assignAdvertisers(state, payload) {
            state.advertisers = payload;
        },
        isLoadingAdvertisers(state) {
            state.loadingAdvertisers = true;
        },
        notLoadingAdvertisers(state) {
            state.loadingAdvertisers = false;
        },
        assignAdvertiserBalance(state, payload) {
            state.advertiserBalance = payload;
        },
        assignCampaigns(state, payload) {
            state.campaigns = payload;
        },
        notLoadingCampaigns(state) {
            state.loadingCampaigns = false;
        },
        isLoadingCampaigns(state) {
            state.loadingCampaigns = true;
        },
        assignLocations(state, payload) {
            state.locations = payload;
        },
        isLoadingLocations(state) {
            state.loadingLocations = true;
        },
        notLoadingLocations(state) {
            state.loadingLocations = false;
        },
        setStats(state, payload) {
            state.stats = payload;
        },
        clearStats(state) {
            state.stats = {};
        },
        setDateRange(state, payload) {
            state.chartStart = payload.chartStart || state.chartStart;
            state.chartEnd = payload.chartEnd || state.chartEnd;
            state.chartInterval = payload.chartInterval || state.chartInterval;
        }
    }
});
